import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import firebase from 'firebase/app'
import 'firebase/analytics'

Vue.config.productionTip = false

let firebaseConfig = {
  apiKey: "AIzaSyARiqVoJtxq18UkUVKdO2qOBkL6dbL_uW0",
  authDomain: "lasrutasdenandomoneda00.firebaseapp.com",
  databaseURL: "https://lasrutasdenandomoneda00-default-rtdb.firebaseio.com",
  projectId: "lasrutasdenandomoneda00",
  storageBucket: "lasrutasdenandomoneda00.appspot.com",
  messagingSenderId: "933464305723",
  appId: "1:933464305723:web:0c89855555433a70e12c1e",
  measurementId: "G-YWDKV1D18F"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.analytics();

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
